export default __webpack_public_path__ + "static/media/vice-principal-signature.6c8b4582.png";